module.exports = __webpack_public_path__ + "img/incoming-payments.29891d51.svg";